import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import TrendingSection from './components/TrendingSection';
import ComparisonSection from './components/ComparisonSection';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hipobuyspread.site';
const faviconUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Hipobuy Spreadsheet Guide',
  url: siteUrl,
  description: 'The ultimate resource for Hipobuy Spreadsheet — curated product finds, shopping guides, comparison tables, safety tips, and expert shopping insights.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Hipobuy Spreadsheet Guide',
  url: siteUrl,
  logo: faviconUrl,
  description: 'The most complete spreadsheet resource hub for product research, shopping guides, comparisons and buyer education.',
  foundingDate: '2025',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: ['English'],
  },
};

export default function Home() {
  return (
    <main>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <CategoryGrid />
      <TrendingSection />
      <ComparisonSection />
      <ArticleSection />
      <CTASection />
      <Footer />
    </main>
  );
}